import { gql } from '@apollo/client';

const EVENT_INDICATORS_QUERY = gql`
  query eventIndicators($filter: ClinicEventFilterInput, $limit: Int) {
    clinicEvents(filter: $filter, limit: $limit) {
      id
      start
      type
    }
  }
`;

export default EVENT_INDICATORS_QUERY;
